import { Link } from 'react-router-dom'
import { Alert, ComingSoonBanner } from '../components/Alert'
import { EmptyState } from '../components/States'

export function BankStatementsPage() {
  return (
    <div className="wrap">
      <div className="phead">
        <div>
          <div className="crumb">
            <Link to="/app">Home</Link> / Bank statements
          </div>
          <h2>Bank statement converter</h2>
          <p className="fs13 muted" style={{ margin: '6px 0 0' }}>
            Turn a PDF statement into clean transaction lines, then import them as bank transactions.
          </p>
        </div>
        <span className="spacer" />
        <span className="tagp t-p1">P1</span>
        <span className="pill">50 credits per line</span>
      </div>

      <ComingSoonBanner feature="Bank statement conversion" />

      <div className="grid2" style={{ alignItems: 'start', gap: 18, marginBottom: 18 }}>
        <div className="card card-p">
          <div className="drop" style={{ minHeight: 130 }}>
            <div style={{ fontSize: 22, marginBottom: 8 }}>↑</div>
            <p style={{ margin: '0 0 4px', fontWeight: 600, fontSize: 14 }}>
              Drop a PDF statement here
            </p>
            <p className="fs12 faint" style={{ margin: 0 }}>
              Uploading is disabled until the converter endpoint is live
            </p>
          </div>
          <p className="hint" style={{ marginTop: 10 }}>
            PDF only, up to <b>10 MB</b>. Password-protected files must be unlocked first.
          </p>
        </div>
        <div className="card card-p">
          <div className="grid2" style={{ gap: 12 }}>
            <div className="fgrp" style={{ margin: 0 }}>
              <label className="fl" htmlFor="bsAccount">
                Bank account
              </label>
              <select className="inp" id="bsAccount" disabled>
                <option>Loaded from QuickBooks</option>
              </select>
            </div>
            <div className="fgrp" style={{ margin: 0 }}>
              <label className="fl" htmlFor="bsPeriod">
                Statement period
              </label>
              <input className="inp mono" id="bsPeriod" placeholder="2026-07" disabled />
            </div>
            <div className="fgrp" style={{ margin: 0 }}>
              <label className="fl" htmlFor="bsDate">
                Date format on page
              </label>
              <select className="inp" id="bsDate" disabled>
                <option>Detect</option>
              </select>
            </div>
            <div className="fgrp" style={{ margin: 0 }}>
              <label className="fl" htmlFor="bsAmount">
                Amount columns
              </label>
              <select className="inp" id="bsAmount" disabled>
                <option>Separate debit / credit</option>
              </select>
            </div>
          </div>
          <div className="sum" style={{ marginTop: 14 }}>
            <div className="m">
              <span className="k">Lines read</span>
              <span className="v">0</span>
            </div>
            <div className="m">
              <span className="k">Balance check</span>
              <span className="v">—</span>
            </div>
            <div className="m">
              <span className="k">Credits</span>
              <span className="v">0</span>
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-h">
          <h3>Extracted lines</h3>
        </div>
        <EmptyState
          icon="🏦"
          title="No statement converted yet"
          body="Once a PDF is read, every line appears here with its date, description, amounts, running balance, guessed payee and read confidence."
        />
      </div>

      <Alert tone="info" title="Unmatched lines still import" style={{ marginTop: 16 }}>
        They land in the bank account uncategorised, exactly as if they came from a bank feed, so you
        can categorise them in QuickBooks. Assign a payee here if you would rather do it up front.
      </Alert>
    </div>
  )
}
